import { Geolocation } from "@capacitor/geolocation";

const capacitorGeolocation = Object.freeze({
	checkPermissions: async () => {
		let status;
		try {
			status = (await Geolocation.checkPermissions()).location;
		} catch (e) {
			status = undefined;
		}
		return status;
	},
	watchPosition: ({onSuccess, onError} = {}) => new Promise((resolve) => {
		let resolved = false;
		let watchId = null;

		const handlePosition = (position, err) => {
			if (resolved) return;
			resolved = true;

			if (watchId) {
				Geolocation.clearWatch({id: watchId});
			}

			if (err) {
				onError && onError(err);
				resolve(null);
				return;
			}

			onSuccess && onSuccess(position);
			resolve(position);
		};

		Geolocation.watchPosition(
			{ enableHighAccuracy: true, timeout: 5000 },
			handlePosition
		).then((id) => {
			watchId = id;
		}).catch((error) => {
			if (!resolved) {
				resolved = true;
				onError && onError(error);
				resolve(null);
			}
		});
	})
});

export default capacitorGeolocation;